/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Email_InvalidInputs */

const en_business_form_email_invalid = /** @type {(inputs: Business_Form_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email address`)
};

const es_business_form_email_invalid = /** @type {(inputs: Business_Form_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor ingresa una dirección de correo válida`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Business_Form_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_email_invalid = /** @type {((inputs?: Business_Form_Email_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Email_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_email_invalid(inputs)
	return en_business_form_email_invalid(inputs)
});